/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CustomerBankAccountDto } from './CustomerBankAccountDto';
export type AcceptEOfferDto = {
    /**
     * Selected payment frequency
     */
    paymentFrequency: AcceptEOfferDto.paymentFrequency;
    /**
     * Selected payment date (date-only string)
     */
    paymentDate: string;
    /**
     * Premium funding quote UUID for instalment plans
     */
    premiumFundingQuoteId?: string;
    /**
     * Declarations accepted (array of booleans). All must be true to proceed.
     */
    declarationsAccepted: Array<boolean>;
    /**
     * Bank account details for fortnightly/monthly instalment payments
     */
    customerBankAccount?: CustomerBankAccountDto;
    /**
     * Annual payment method selected by the client
     */
    annualPaymentMethod?: AcceptEOfferDto.annualPaymentMethod;
};
export namespace AcceptEOfferDto {
    /**
     * Selected payment frequency
     */
    export enum paymentFrequency {
        WEEKLY = 'WEEKLY',
        FORTNIGHTLY = 'FORTNIGHTLY',
        MONTHLY = 'MONTHLY',
        ANNUAL = 'ANNUAL',
    }
    /**
     * Annual payment method selected by the client
     */
    export enum annualPaymentMethod {
        CREDIT_CARD = 'CREDIT_CARD',
        BANK_TRANSFER = 'BANK_TRANSFER',
    }
}

